import { Box, Paper } from "@mui/material";
import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import StepProgressBar from "src/components/CustomerOnbording/StepProgressBar";
import CustomLoader from "src/shared_components/CustomLoader";

const steps = [
  { label: "Welcome" },
  { label: "Add Logo" },
  { label: "Add Location" },
  { label: "Add Vehicle Type" },
  { label: "Add Rate Info" },
  { label: "Add Code Sequence" },

];

const getActiveStep = (pathname: string): number => {
  if (pathname.includes("add-logo")) return 1;
  if (pathname.includes("add-location")) return 2;
  if (pathname.includes("add-assetType")) return 3;
  if (pathname.includes("add-rateInfo")) return 4;
  if (pathname.includes("add-codeSequence")) return 5;

  return 0;
};

const CustomerOnboardingLayout: React.FC = () => {
  const location = useLocation();
  const activeStep = getActiveStep(location.pathname);

  return (
    <Box
      sx={{
        height: "100vh",
        background: ", #e0f7fa",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={3} sx={{ p: 4 }}>
        <Suspense fallback={<CustomLoader />}>
          <StepProgressBar steps={steps} activeStep={activeStep} />
          <Outlet />
        </Suspense>
      </Paper>

    </Box>
  );
};

export default CustomerOnboardingLayout;
